module.exports = __webpack_public_path__ + "static/media/coke.cd6c7e21.svg";